/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import {SalesDtoModel, SalesListViewModel, SalesVoModel} from '@well/domain';
import {Observable} from 'rxjs';
import { AbstractResourceService, JsonApiResource, QueryParams } from '@irian-ro/abstract-resource';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SalesResourceService extends AbstractResourceService<
  SalesListViewModel,
  SalesDtoModel,
  undefined,
  undefined
> {
  constructor(
    protected httpClient: HttpClient,
    private environmentService: EnvironmentService
  ) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('salesUrl'),
      SalesListViewModel,
      SalesDtoModel,
      undefined,
      undefined
    );
  }

  findAllSalesVo(query?: any,
          additionalParams?: any): Observable<JsonApiResource<SalesVoModel[], any>> {
    const queryString = new QueryParams(
      query,
      additionalParams ? additionalParams : []
    ).toString();
    return this.httpClient.get<JsonApiResource<SalesVoModel[], any>>(`${this.url}/vo/salesSummaryVo${queryString}`).pipe(
      map((jsonApiResource) => {
        jsonApiResource.data = jsonApiResource.data.map((item: any) => AbstractResourceService.resourceMapper(this.vType, item)
        );
        jsonApiResource.meta = AbstractResourceService.resourceMapper(
          this.mvType,
          jsonApiResource.meta
        );
        return jsonApiResource;
      })
    );
  }

}
